export default __webpack_public_path__ + "static/media/MaxLogoWhite.3fd22ccf.png";